(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    $(document).ready(function () {
      const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: false,
        fade: false,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 750,
            settings: 'unslick',
          },
        ],
      };
      const ssContainer = $('#ts-announcement-bar-custom');
      const ss = $(ssContainer).slick(settings);

      $(window).on('resize', function () {
        const windowWidth = $(window).width();

        if (windowWidth < 750 && !ss.hasClass('slick-initialized')) {
          ss.slick('reinit');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    $(document).ready(function () {
      $('#ts-collection-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '#ts-collection-carousel-prev',
        nextArrow: '#ts-collection-carousel-next',
        mobileFirst: true,
        centerMode: true,
        responsive: [
          {
            breakpoint: 420,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: false,
            },
          },
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              centerMode: false,
            },
          },
        ],
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    $(document).ready(function () {
      const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        mobileFirst: true,
        centerMode: true,
        centerPadding: '50px',
        responsive: [
          {
            breakpoint: 750,
            settings: 'unslick',
          },
        ],
      };
      const ssContainer = $('#ts-blog-posts-custom');
      const ss = $(ssContainer).slick(settings);

      $(window).on('resize', function () {
        const windowWidth = $(window).width();

        if (windowWidth < 750 && !ss.hasClass('slick-initialized')) {
          ss.slick('reinit');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  $(document).on('click', '#mobile-sticky-header-search-button', () => {
    $('#mobile-sticky-header-search').addClass('twcss-max-w-full').removeClass('twcss-overflow-hidden');
  });

  $(document).on('click', '#mobile-sticky-header-search-close', () => {
    $('#mobile-sticky-header-search').removeClass('twcss-max-w-full').addClass('twcss-overflow-hidden');
  });

  $(document).on('click', '#ask-us', () => {
    if (typeof zE !== 'undefined') {
      zE('webWidget', 'open');
    } else {
      console.warn('Zendesk widget not loaded');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    $(document).ready(function () {
      $('.ts-logo-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        arrows: false,
        fade: false,
        mobileFirst: true,
        centerMode: true,
        centerPadding: '7.5rem',
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: false,
            },
          },
          {
            breakpoint: 1028,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 1,
              centerMode: false,
            },
          },
        ],
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multirow"] && !Shopify.designMode) return;
  try {
    
  $(document).on("click", ".ask-us-btn", () => {
    zE('webWidget', 'open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    $(document).ready(function () {
      $('#ts-product-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '#ts-product-carousel-prev',
        nextArrow: '#ts-product-carousel-next',
        mobileFirst: true,
        centerMode: false,
        responsive: [
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '25px',
            },
          },
          {
            breakpoint: 720,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '25px',
            },
          },
          {
            breakpoint: 1028,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '50px',
            },
          },
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              centerMode: false,
            },
          },
        ],
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description"] && !Shopify.designMode) return;
  try {
    
  (function () {
    $(document).ready(function () {
      const readMore = $('#product-description-read-more');

      if (readMore) {
        const shortDesc = $('#product-description-short');
        const longDesc = $('#product-description-full');
        const readLess = $('#product-description-read-less');

        $(readMore).on('click', (e) => {
          e.preventDefault();

          shortDesc.addClass(['twcss-absolute', 'twcss-opacity-0', 'twcss-pointer-events-none']);
          longDesc.removeClass(['twcss-absolute', 'twcss-opacity-0', 'twcss-pointer-events-none']);
          readMore.addClass(['twcss-opacity-0', 'twcss-pointer-events-none']);
          readLess.removeClass(['twcss-opacity-0', 'twcss-pointer-events-none']);
        });

        $(readLess).on('click', (e) => {
          e.preventDefault();

          longDesc.addClass(['twcss-absolute', 'twcss-opacity-0', 'twcss-pointer-events-none']);
          shortDesc.removeClass(['twcss-absolute', 'twcss-opacity-0', 'twcss-pointer-events-none']);
          readLess.addClass(['twcss-opacity-0', 'twcss-pointer-events-none']);
          readMore.removeClass(['twcss-opacity-0', 'twcss-pointer-events-none']);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-finder"] && !Shopify.designMode) return;
  try {
    
  $(document).on("click", ".ask-us-btn", () => {
    zE('webWidget', 'open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-key-features"] && !Shopify.designMode) return;
  try {
    
  (function () {
    $(document).ready(function () {
      $('#ts-product-key-features-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '#ts-product-key-features-carousel-prev',
        nextArrow: '#ts-product-key-features-carousel-next',
        mobileFirst: true,
        centerMode: true,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: false,
            },
          },
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              centerMode: false,
            },
          },
        ],
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
